import { render, staticRenderFns } from "./AlarmPointsTable.vue?vue&type=template&id=396f021e&scoped=true"
import script from "./AlarmPointsTable.vue?vue&type=script&lang=ts"
export * from "./AlarmPointsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396f021e",
  null
  
)

export default component.exports